import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Row, Col, Spin, Alert, Image } from 'antd';
import { UserOutlined, LockOutlined, LoadingOutlined } from '@ant-design/icons';
import * as userActions from '../../redux/actions/userActions';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo-img.png';
import { getCookie } from '../../services/cookies';

const Login = props => {
  const navigate = useNavigate();
  const ssfToken = getCookie('ssfToken');
  const [requiredOtp, setRequiredOtp] = useState(false);
  const [otpHash, setOtpHash] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const mountedRef = useRef(true);
  // Re-runs whenever isLoggedIn flips true (not just on mount) — otherwise a successful
  // login never navigates away: signin() only updates the ssfToken cookie and redux state,
  // it doesn't itself navigate, so without this dependency the user is left stuck on
  // /login with the submit button spinning forever (loading is only reset on the error path).
  useEffect(() => {
    redirect();
    return () => {
      mountedRef.current = false;
    };
  }, [props.isLoggedIn]);

  let redirect = () => {
    if (!!(props.isLoggedIn && ssfToken)) {
      navigate('/');
    }
  };

  const onFinish = async values => {
    setErrorMessage('');
    setLoading(true);
    await props
      .signin(values.email, values.password, values.otp ? values.otp : false, otpHash)
      .then(
        res => {
          if (!mountedRef.current) return null;
          return res;
        },
        errorReponse => {
          setLoading(false);
          if (!mountedRef.current) return null;

          //console.log(errorReponse);
          if (errorReponse.errors !== undefined) {
            for (var i = 0; i < errorReponse.errors.length; i++) {
              var errorObj = errorReponse.errors[i];
              if (errorObj.extensions.code == 'OTP') {
                setOtpHash(errorObj.extensions.hash);
                setRequiredOtp(true);
              } else if (errorObj.extensions.code == 'INVALID_OTP') {
                setErrorMessage(errorObj.message);
              } else if (errorObj.extensions.code == 'USER_SUSPENDED') {
                setErrorMessage('Your account has been temporarily suspended. Please contact the Administrator for assistance.');
              } else {
                setErrorMessage('Invalid username and password');
              }
            }
          }
          return errorReponse;
        }
      )
      .catch(error => {
        setLoading(false);
        console.log('||Error: ', error);
      });
    // setLoading(false);
    return true;
  };
  const showLogin = () => {
    setRequiredOtp(false);
    setOtpHash('');
    setErrorMessage('');
    // setLoading(false);
  };

  let render = () => {
    let { status } = props;
    //let loading = status.type === 'loading' ? true : false;
    //console.log(status);
    return (
      <Row className="login-p">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className="login-section">
            {/* <div className='admin-name'>Shubhreet Sandhu</div>
						<div className='welcome-msg'>Hi, Welcome Back!</div>
						<p className='welcome-txt'>How do i get started lorem ipsum dolor at?</p> */}
            <div className="form-card">
              <div className="logo">
                <img src={Logo} alt="Ansel Adams" />
              </div>
              <div className="form-heading">Login</div>
              <div className="form-section">
                {errorMessage != '' ? (
                  <div style={{ margin: '20px auto' }}>
                    <Alert type="error" message={errorMessage} />
                  </div>
                ) : (
                  ''
                )}
                {!requiredOtp ? (
                  <Form className="log-in-form" layout="vertical" onFinish={onFinish}>
                    <Form.Item label="Email address" name="email" rules={[{ required: true, message: 'Please input your email' }]}>
                      <Input type="email" prefix={<UserOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your password',
                        },
                      ]}
                    >
                      <Input.Password prefix={<LockOutlined className="prefix-icon" />} />
                    </Form.Item>

                    <div style={{ textAlign: 'right' }}>
                      <a className="link-text" href="/reset-password">
                        Forgot Password?
                      </a>
                    </div>
                    <Spin spinning={loading} size="large" indicator={<LoadingOutlined />}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-button">
                          Login
                        </Button>
                      </Form.Item>
                    </Spin>
                  </Form>
                ) : (
                  <Form className="otp-form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                      hidden="true"
                      label="Email address"
                      name="email"
                      rules={[{ required: true, message: 'Please input your email' }]}
                    >
                      <Input type="email" prefix={<UserOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <Form.Item
                      hidden="true"
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your password',
                        },
                      ]}
                    >
                      <Input.Password prefix={<LockOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <Form.Item label="OTP" name="otp" rules={[{ required: true, message: 'Please input your otp' }]}>
                      <Input.Password prefix={<LockOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <div style={{ textAlign: 'right' }}>
                      <a className="link-text" onClick={showLogin}>
                        Back to Login
                      </a>
                    </div>

                    <Spin spinning={loading} size="large" indicator={<LoadingOutlined />}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-button">
                          Submit
                        </Button>
                      </Form.Item>
                    </Spin>
                  </Form>
                )}
              </div>
            </div>
            <div className="copyright">&copy;2010-2022 The Anseladams Gallery. All rights reserved.</div>
          </div>
        </Col>
        {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<div className='image-section'>
						<div className='welcome-img'>
							
							<div className='welcome-msg2'>Welcome to Shubhreet Sandhu</div>
							<p className='welcome-txt2'>Lorem ipsum is simply dummy text of the printing and typesetting industry.</p>
						</div>
					</div>
				</Col> */}
      </Row>
    );
  };

  return render();
};

export default connect(state => {
  return {
    ...state.status,
    ...state.user,
  };
}, userActions)(Login);
